module.exports = __webpack_public_path__ + "static/media/6.9.17920f33.zip";